import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/close.svg'
import _imports_1 from '@/assets/img/hand_stop.svg'


const _withScopeId = n => (_pushScopeId("data-v-88da0140"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modalContent" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "icon"
}, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "w-100 mt-5 pt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showCloseButton)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _imports_0,
            class: "closeImage",
            style: {"height":"30px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
        _createElementVNode("h1", null, _toDisplayString(_ctx.description), 1)
      ]),
      (_ctx.firstButtonText || _ctx.secondButtonText)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.firstButtonText)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary w-75 mx-auto mb-2",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.callback1()))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.firstButtonText), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.secondButtonText)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-secondary w-75 mx-auto",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.callback2()))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.secondButtonText), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}